// COVRFLY® — Product Summary Bar v1.2
// Fixed top info bar with variant sync + header relay
// Aparece cuando el h1 del producto sale del viewport
(function() {
  'use strict';

  // Solo mobile
  if (window.matchMedia('(min-width: 992px)').matches) return;

  var bar = document.querySelector('[data-cf-product-summary]');
  if (!bar) return;

  // Buscar el titulo H1 del producto
  var title = document.querySelector('.product__title') || document.querySelector('h1');
  if (!title) return;

  // ─── Estado: titulo fuera del viewport ───
  var titleGone = false;
  var headerVisible = true; // Header empieza visible

  function updateBarVisibility() {
    if (titleGone && !headerVisible) {
      bar.classList.add('cf-summary-visible');
    } else {
      bar.classList.remove('cf-summary-visible');
    }
  }

  // ─── Show/Hide via IntersectionObserver ───
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        titleGone = true;
      } else {
        titleGone = false;
      }
      updateBarVisibility();
    });
  }, { threshold: 0 });

  observer.observe(title);

  // ─── Tap-to-scroll: tocar la barra sube al producto ───
  bar.addEventListener('click', function(e) {
    if (e.target.closest('a, button')) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  bar.style.cursor = 'pointer';

  // ─── Header relay: cuando el header aparece, la barra se esconde ───
  document.addEventListener('covrfly:header-visible', function() {
    headerVisible = true;
    updateBarVisibility();
  });
  document.addEventListener('covrfly:header-hidden', function() {
    headerVisible = false;
    updateBarVisibility();
  });

  // ─── Variant sync: modelo + acabado + precio ───
  var modelSpan = bar.querySelector('[data-cf-summary-model]');
  var acabadoSpan = bar.querySelector('[data-cf-summary-acabado]');
  var priceSpan = bar.querySelector('[data-cf-summary-price]');

  function updateInfo() {
    var modelSelect = document.querySelector('select[name="options[Elige tu Modelo]"]')
      || document.querySelector('select[name="options[Modelo]"]');
    var acabadoSelect = document.querySelector('select[name="options[Acabado]"]');
    var magsafeSelect = document.querySelector('select[name="options[MagSafe]"]');

    // Modelo
    var modelVal = modelSelect ? modelSelect.value : '';
    if (modelSpan) {
      modelSpan.textContent = modelVal;
    }

    // Acabado + MagSafe combinados estilo Apple
    var parts = [];
    if (acabadoSelect && acabadoSelect.value) {
      parts.push(acabadoSelect.value);
    }

    // MagSafe: SOLO si es iPhone (NUNCA Samsung/Galaxy)
    var isSamsung = modelVal.toLowerCase().indexOf('galaxy') !== -1
      || modelVal.toLowerCase().indexOf('samsung') !== -1;

    if (!isSamsung && magsafeSelect) {
      var val = magsafeSelect.value.trim().toLowerCase();
      if (val === 'sí' || val === 'si' || val === 'yes' || val === 'con magsafe' || val === 'magsafe') {
        parts.push('MagSafe');
      }
    }

    if (acabadoSpan) {
      acabadoSpan.textContent = parts.join(' - ');
    }
  }

  function thumbSrc(src) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src.indexOf('width=') > -1) {
      src = src.replace(/width=\d+/, 'width=144');
    } else {
      src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=144';
    }
    if (src.indexOf('height=') > -1) {
      src = src.replace(/height=\d+/, 'height=144');
    }
    return src;
  }

  function updateThumb() {
    var imgEl = bar.querySelector('.cf-product-summary__thumb img');
    if (!imgEl) return;

    var modelSelect = document.querySelector('select[name="options[Elige tu Modelo]"]')
      || document.querySelector('select[name="options[Modelo]"]');
    var acabadoSelect = document.querySelector('select[name="options[Acabado]"]');
    var magsafeSelect = document.querySelector('select[name="options[MagSafe]"]');

    var modelVal = modelSelect ? modelSelect.value : '';
    var acabadoVal = acabadoSelect ? acabadoSelect.value : '';
    var magsafeVal = magsafeSelect ? magsafeSelect.value.trim().toLowerCase() : '';

    var isIphone = modelVal.toLowerCase().indexOf('galaxy') === -1
      && modelVal.toLowerCase().indexOf('samsung') === -1;
    var isGlossy = acabadoVal.toLowerCase().indexOf('glossy') !== -1;
    var noMagSafe = magsafeVal.indexOf('no') !== -1 || magsafeVal.indexOf('sin') !== -1;

    // iPhone + Glossy + Sin MagSafe → mostrar versión con MagSafe (más premium)
    if (isIphone && isGlossy && noMagSafe) {
      var jsonEl = document.querySelector('[data-cf-product-variants]');
      if (jsonEl) {
        try {
          var variants = JSON.parse(jsonEl.textContent);
          // option1=Modelo, option2=MagSafe, option3=Acabado
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var sameModel = (v.option1 || '').toLowerCase() === modelVal.toLowerCase();
            var sameAcabado = (v.option3 || '').toLowerCase() === acabadoVal.toLowerCase();
            var opt2 = (v.option2 || '').trim().toLowerCase();
            var hasMagSafe = opt2 === 'sí' || opt2 === 'si' || opt2 === 'yes' || opt2 === 'con magsafe';
            if (sameModel && sameAcabado && hasMagSafe) {
              if (v.featured_image && v.featured_image.src) {
                imgEl.src = thumbSrc(v.featured_image.src);
                return;
              }
              break;
            }
          }
        } catch (e) {}
      }
    }

    // Fallback: imagen activa de la galería
    var activeImg = document.querySelector('.product__media-item.is-active img');
    if (activeImg && activeImg.src) {
      imgEl.src = thumbSrc(activeImg.src);
    }
  }

  function cleanPrice(str) {
    return str.replace(/\.00/g, '').replace(/MXN/gi, '').trim();
  }

  function updatePrice() {
    var sectionEl = document.querySelector('[data-section-type="main-product"]');
    if (sectionEl) {
      var sectionId = sectionEl.getAttribute('data-section-id');
      var priceEl = document.querySelector('#price-' + sectionId + ' .price-item--sale')
        || document.querySelector('#price-' + sectionId + ' span.price-item--regular')
        || document.querySelector('#price-' + sectionId + ' .price-item');
      if (priceEl && priceSpan) {
        var newPrice = priceEl.textContent.trim();
        if (newPrice) {
          priceSpan.textContent = cleanPrice(newPrice);
        }
      }
    }
  }

  // Escuchar cambios de variante
  var variantSelects = document.querySelector('variant-selects');
  if (variantSelects) {
    variantSelects.addEventListener('change', function() {
      updateInfo();
      setTimeout(function() {
        updatePrice();
        updateThumb();
      }, 700);
    });
  }

  // Initial sync
  updateInfo();
  if (priceSpan && priceSpan.textContent) {
    priceSpan.textContent = cleanPrice(priceSpan.textContent);
  }
})();
